import { Box, Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { type EIconCategory, getAppIcon } from '@src/helper/iconRegistry';
import React from 'react';

interface FeatureCardWidgetProps {
    title: string;
    description: string;
    imagePath: string;
    iconCategory: EIconCategory;
    onClick: () => void;
}

function FeatureCardWidget({ title, description, imagePath, iconCategory, onClick }: FeatureCardWidgetProps) {
    const theme = useTheme();

    return (
        <Card
            sx={{
                flex: 1,
                border: `1.5px solid ${theme.palette.mode === 'dark' ? alpha(theme.palette.primary.main, 0.5) : alpha(theme.palette.divider, 0.2)}`,
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`,
                    borderColor: theme.palette.primary.main,
                },
                transition: 'all 0.2s ease',
            }}
        >
            <CardActionArea onClick={onClick}>
                <CardMedia
                    component="img"
                    height="140"
                    image={imagePath}
                    alt={title}
                    sx={{
                        filter: theme.palette.mode === 'dark' ? 'brightness(0.8) contrast(1.1)' : 'none',
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                />
                <CardContent sx={{ p: { xs: 2, md: 2, lg: 3 } }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Box sx={{ color: theme.palette.primary.main }}>{getAppIcon(iconCategory)}</Box>
                        <Typography variant="h6" component="div" sx={{ fontWeight: 500 }}>
                            {title}
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default FeatureCardWidget;
